import { useEffect, useState, useRef } from 'react';

const DEFAULT_PAGE_TITLE = 'Xvantage GDS';

/** updatePageTitle: Sets page title for the consuming View component as the input string.
 * For setting page title on iFramed pages, see:
 * https://imonline.atlassian.net/wiki/spaces/DigitalT/pages/3070820435/X4C+Page+Titles#iFramed-Pages */
export function usePageTitle() {
  const prevPageTitle = useRef(document.title);
  const [pageTitle, setPageTitle] = useState(document.title);

  const updatePageTitle = (newPageTitle: string) => {
    if (newPageTitle && pageTitle !== newPageTitle) {
      setPageTitle(newPageTitle);
    }
  };

  useEffect(() => {
    document.title = pageTitle;
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      document.title = prevPageTitle.current ?? DEFAULT_PAGE_TITLE;
    };
  }, [pageTitle]);

  return { pageTitle, updatePageTitle };
}
